import { Component, Inject, Input, OnInit } from '@angular/core';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { CalculatorTypes } from '../calculator/enums/calculator-types.enum';
import { CalculatorInput } from '../calculator/interfaces/calculator-input.interface';
import { IMetricsService } from '../../../modules/settings/crm-metrics/services/metrics-service.interface';
import { CalculatorHelpers } from '../calculator/helpers/calculator-helpers';

@Component({
  selector: 'gtd-calculator-view',
  templateUrl: './calculator-view.component.html',
})
@DestroySubscribers()
export class CalculatorViewComponent implements OnInit {
  @Input() formula: string;
  public inputs: CalculatorInput[] = [];
  public Types = CalculatorTypes;
  public isLoading = true;

  public operators: { [key: string]: string } = {
    '*': '×',
    '/': '÷',
    '+': '+',
    '-': '-',
    '(': '(',
    ')': ')',
  };

  public calculatorHelpers = CalculatorHelpers;

  subscribers: any = {};

  constructor(@Inject('IMetricsService') private metricsService: IMetricsService) {}

  ngOnInit(): void {
    this.subscribers.metricsData = this.metricsService.getBaseMetrics().subscribe((metrics) => {
      this.inputs = this.calculatorHelpers.parseFormula(this.formula, metrics);
      this.isLoading = false;
    });
  }
}
